// src/helpers/shareHelpers.js
/**
 * Return the canonical URL for a Season page.
 * Adjust the path if your route pattern changes.
 */
export function getSeasonUrl(seasonId) {
    return `${window.location.origin}/`;
}